import { baseQuery } from "src/store/helpers/baseQuery";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient from "./rtkClient";

export const eventsApi = createApi({
    reducerPath: "eventsApi",
    tagTypes: ["ActivityReport", "Events"],
    keepUnusedDataFor: 300,
    baseQuery,
    endpoints: (builder) => ({
        getActivityReport: rtkClient.getActivityReport(builder),
        getEvents: rtkClient.getEvents(builder),
    }),
});

export const { useGetActivityReportQuery, useGetEventsQuery, useLazyGetEventsQuery, usePrefetch } = eventsApi;
